import { render, staticRenderFns } from "./IconMultiOportunity.vue?vue&type=template&id=67e7b12f"
import script from "./IconMultiOportunity.vue?vue&type=script&lang=js"
export * from "./IconMultiOportunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports